import { axiosInstance } from './axiosInstance';

export function loginApi(data) { 
    return axiosInstance().post("/api/v1/login/super-admin",data)
}
